import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import HomePage from './HomePage';

const App = () => {
    return <AppContainer>
        <Switch>
            <Route path={['/', '/home']} exact={true} component={HomePage}/>
        </Switch>
    </AppContainer>;
};

export default App;
